<template>
  <div class="seachLayout">
    <slot></slot>
    <div class="bnts">
      <slot name="button"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.seachLayout {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f2f5;
  overflow: hidden;
  .item {
    display: inline-block;
    margin-right: 15px;
    min-width: 180px;
    .ant-select {
      min-width: 140px;
    }
    .input {
      display: inline-block;
      width: 160px;
      vertical-align: top;
    }
    label {
      padding-right: 8px;
      line-height: 40px;
    }
  }
  .bnts {
    // float: right;
    display: inline-block;
  }
}
</style>
